query TravelPolicy($id: UUID!) {
  travelPolicy(id: $id) {
    id
    _rowTimestamp
    _isUpdatable
    _isDeletable
    description
    currencyId
    companyCurrency {
      id
      isoCode
      name
    }
    isDefaultCustomizable
    isContractual
    isCompanion
    companionTickets
    companionAmount
    isEconomyClassAllowed
    isPremiumClassAllowed
    isBusinessClassAllowed
    isFirstClassAllowed
    isCharterClassAllowed
    travelPolicyAllowancesByTravelPolicyId(orderBy: SORT_ORDER_ASC) {
      nodes {
        id
        _rowTimestamp
        _isUpdatable
        _isDeletable
        expenditureTypeId
        expenditureType {
          expenditureType
        }
        country1Id
        country2Id
        stateRegion1Id
        stateRegion2Id
        policyAllowance
        policyMiles
        isAllowanceCustomizable
      }
      totalCount
    }
  }
}
